import React from "react";
import Text from "../../../../Components/Text/Text";
import MyButton from "../../../../Components/Button/Button";
import ImageComp from "../../../../Components/ImageComp/ImageComp";
import HeaderSection from "../../../../Components/HeaderSection/HeaderSection";

export default function EachPressReleaseComponentOldVersion({
  PressHeading,
  PressDate,
  PressImage,
  PressImageWidth,
  PressDetails,
  PressDetails2,
  TopDetails
}) {
  return (
    <>
      <div className="Page_Body">
        <div className="Page_Body_wraper">
          <HeaderSection
            text="Media Center   <span>/</span>"
            text1="  Our News"
            RouteLink1="/our_news"
            Color1="#6C6C6C"
            Color2="black"
          />
          <div className="PressReleaseBody">
            <div className="PressReleaseBodyTopText">
              <Text
                text={PressHeading}
                FontWeight="900"
                FontSize={"3.5rem"}
                font
                Margin="50px 0px 50px 0px"
              />
              <Text
                text={PressDate}
                FontWeight="500"
                Color="#808080"
                FontSize={"1.8rem"}
                font
                Margin="50px 0px 20px 0px"
              />
              <Text
              text={TopDetails}
              FontSize={"3.2rem"}
              Margin="0px 0px 50px 0px"
              Padding="0px 150px 0px 0px"
            />
            </div>

            

            <div className="PressRelease_Img_Sec">
              <div className="Right_Sec_Mob">
                <ImageComp Src={PressImage} Width={PressImageWidth} />
              </div>
              <div className="Left_Sec">
                <Text text={PressDetails} FontSize="2.1rem" />
              </div>
              <div className="Right_Sec">
                <ImageComp Src={PressImage} Width={PressImageWidth} />
              </div>
            </div>
            <Text text={PressDetails2} />

            <div className="Press_Release_bottom">
              <div className="SiteLinkSec">
                <Text
                  text="For any inquiries, please reach out at "
                  Margin="0px 2px 0px 0px"
                  FontSize="1.8rem"
                />
                <MyButton
                  RouteLink="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@dynasysnetworks.com"
                  FontSize="1.8rem"
                  text="info@dynasysnetworks.com"
                  FontWeight="400"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="borderSec">
        <div class="border"></div>
      </div>
    </>
  );
}
